import { types } from "../Types/agent";

const initialState: any = {
  agent: null,
  messages: [],
  drafts: [],
  avatars: [],
  stats: null,
  testResult: null,
  loading: false,
  saving: false,
  generating: false,
  testing: false,
  sendingId: null,
  error: null,
};

const agentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.GET_AGENT:
      return { ...state, loading: true, error: null };
    case types.GET_AGENT_SUCCESS:
      return { ...state, loading: false, agent: action.payload };
    case types.GET_AGENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.UPDATE_AGENT:
      return { ...state, saving: true };
    case types.UPDATE_AGENT_SUCCESS:
    case types.ADD_AGENT_EXAMPLE_SUCCESS:
      return { ...state, saving: false, agent: action.payload };
    case types.UPDATE_AGENT_FAILURE:
      return { ...state, saving: false };    case types.TEST_AGENT:
      return { ...state, testing: true, testResult: null };
    case types.TEST_AGENT_SUCCESS:
      return { ...state, testing: false, testResult: action.payload };
    case types.TEST_AGENT_FAILURE:
      return { ...state, testing: false, testResult: { error: action.payload } };
    case types.CLEAR_AGENT_TEST:
      return { ...state, testResult: null };

    case types.GET_INBOX_MESSAGES:
      return { ...state, loading: true };
    case types.GET_INBOX_MESSAGES_SUCCESS:
      return { ...state, loading: false, messages: action.payload };
    case types.GET_INBOX_MESSAGES_FAILURE:
      return { ...state, loading: false };

    case types.GET_DRAFTS:
      return { ...state, loading: true };
    case types.GET_DRAFTS_SUCCESS:
      return { ...state, loading: false, drafts: action.payload };
    case types.GET_DRAFTS_FAILURE:
      return { ...state, loading: false };

    case types.GET_DRAFT_STATS_SUCCESS:
      return { ...state, stats: action.payload };

    case types.GENERATE_DRAFT:
      return { ...state, generating: true };
    case types.GENERATE_DRAFT_SUCCESS:
      return { ...state, generating: false };
    case types.GENERATE_DRAFT_FAILURE:
      return { ...state, generating: false };

    case types.DECIDE_DRAFT_SUCCESS:
      return {
        ...state,
        drafts: state.drafts.map((draft: any) =>
          draft.id === action.payload.id ? action.payload : draft
        ),
      };

    case types.SEND_DRAFT:
      return { ...state, sendingId: action.payload.id };
    case types.SEND_DRAFT_SUCCESS:
    case types.SEND_DRAFT_FAILURE:
      return { ...state, sendingId: null };

    case types.START_WATCH_SUCCESS:
      return { ...state, watch: action.payload };

    case types.GET_AVATARS:
      return { ...state, loading: true };
    case types.GET_AVATARS_SUCCESS:
      return { ...state, loading: false, avatars: action.payload };
    case types.CREATE_AVATAR:
      return { ...state, saving: true };
    case types.CREATE_AVATAR_SUCCESS:
      return { ...state, saving: false, avatars: [action.payload, ...state.avatars] };
    case types.CREATE_AVATAR_FAILURE:
      return { ...state, saving: false };
    case types.SYNC_AVATAR_SUCCESS:
    case types.REQUEST_AVATAR_CONSENT_SUCCESS:
    case types.SET_DEFAULT_AVATAR_SUCCESS: {
      const updatedId = action.payload.id;
      const nextAvatars = state.avatars.map((entry: any) => {
        if (entry.id === updatedId) return action.payload;
        if (action.type === types.SET_DEFAULT_AVATAR_SUCCESS && entry.isDefault) {
          return { ...entry, isDefault: false };
        }
        return entry;
      });
      return { ...state, avatars: nextAvatars };
    }
    case types.DELETE_AVATAR_SUCCESS:
      return { ...state, avatars: state.avatars.filter((entry: any) => entry.id !== action.payload) };

    case types.CREATE_DRAFT_VIDEO:
      return { ...state, generating: true };
    case types.CREATE_DRAFT_VIDEO_SUCCESS:
    case types.CREATE_DRAFT_VIDEO_FAILURE:
      return { ...state, generating: false };

    default:
      return state;
  }
};

export default agentReducer;
